// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.employee.security.LoginUsingExistingSessionRequest */
/* istanbul ignore next */
@GandalfModel
export class LoginUsingExistingSessionRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { message: 'User Session cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	httpSessionId!: string | null;

	@GandalfProperty({ designType: Number })
	userSessionId!: number | null;

}
